"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  com: {
    rent: {
      settleOfficeNameEn: 'contract party',
      importStopPast: 'Import suspension of charter and flight',
      stopImportVoyageFee: 'Write off past charter outage information',
      parnerWarn: 'Please fill in the actual payer',
      otherFeeWarn: 'Please fill in miscellaneous fees',
      mustHasInvoiceNo: 'Must Has InvoiceNo',
      existMess: 'Maintenance data does not exist',
      actualRobMessage: 'There is no actual return oil storage data cannot be added',
      estRedeliverRobMessage: 'There is no estimate return oil storage data cannot be added',
      robMessage: 'The data of unmaintainable estimated returnable oil in actual returnable oil storage exist',
      toVoidThis: 'ToVoid this invoice',
      messAge: 'Please select at least two pieces of data',
      huanDelTime: 'Time of return (UTC/LT)',
      lastInstallment: 'Final issue',
      currencyCodeMessage: 'Data does not comply with the application for consolidated payment',
      mergeApply: 'Consolidated payment request',
      errMsg: 'Data that has been audited cannot be deleted',
      lookApprove: 'Review the approval process',
      stopProportion: 'Calculation ratio',
      stopPrice: 'Stop day rent',
      stopDay: 'Days off rent',
      stopDescription: 'Stop rent description',
      stopPast: 'Write off the past',
      openLastMsg: 'Whether to open the last phase',
      closeLastMsg: 'Whether to close the last phase?',
      openLast: 'Last phase of opening',
      closeLast: 'Closing the last phase',
      DeleteAudit: 'Cancel audit',
      autidSuccess: 'Successful audit',
      autidFaild: 'Cancel audit successfully',
      estOil: 'Estimated fuel consumption',
      deliverTitle: 'Deposit oil on board',
      returnTitle: 'Return the oil on board',
      eatDeliverTitle: 'Expected to return the oil on board',
      stopType: 'Stop  deduction',
      naviType: 'type',
      navigationButton: 'Add-on rental',
      saveCve: 'Add CVE',
      rentText: 'Rental cost',
      chargeRentText: 'Charge off rental cost',
      manageText: 'Manage cost',
      chargeManageText: 'Charge off manage cost',
      aRedPort: 'Red Information',
      aDelTime: 'Del Information(UTC/LT)',
      aDelPort: 'Del Information',
      returnShip: 'Redelivery information',
      periodRentDay: 'Rent Per Day',
      periodRentType: 'Period Rent Type',
      periodEndTime: 'Rent End Time',
      periodStartTime: 'Rent Start Time',
      priceRentTitle: 'Charter invoice',
      monthlyExpensesTitle: 'External vessel invoice',
      inPriceRentTitle: 'In Charter invoice',
      apply: 'Application for payment',
      delete: 'delete',
      approve: 'Examine and approve',
      chartererName: 'Charterer Name',
      chartererComm: 'Charterer Commission',
      chartererCommRate: 'Charterer Commission Rate',
      freightComm: 'Freight Commission',
      freightCommRate: 'Freight Commission Rate',
      brokerComm: 'Broker Commission',
      contractNo: 'contractNo',
      invoiceNo: 'Invoice No',
      invoiceType: 'Invoice Type',
      invoiceDate: 'Invoice Date',
      dueDate: 'Due Date',
      invalidFlag: 'Is Invalid',
      currencyCode: 'Invoice Currency',
      invoiceAmount: 'Invoice Amount',
      installment: 'Installment',
      checkFlag: 'Is Checked',
      title: 'Charter freight invoice',
      rentInFreightTitle: 'Rent In Ship Freight Invoice',
      rentOutFreightTitle: 'Rent Out Ship Freight Invoice',
      currency: 'Invoice Currency/Exchange Rate',
      InvoiceInformation: 'Invoice information',
      sundryFees: 'Sundry fees cost subject is not null',
      bdiDate: 'The index rental time cannot be empty',
      basicFees: 'Rent expense account cannot be empty',
      selectOne2: ' only select one invoice to invalidate',
      basicBegin: 'The start time of rental fees cannot be empty',
      basicEnd: 'The end time of rental fees cannot be empty',
      rpType: 'Is Credit',
      autoTaxInvFlag: 'Is Auto Tax Invoice',
      bankInfo: 'Bank Info',
      remark: 'Remark',
      vesselCmpInfo: 'Vessel Company Info',
      manageCmpInfo: 'Manage Company Info',
      contractTitle: 'contract information',
      finalFlag: 'finalFlag',
      coaContractNo: 'Coa Contract No',
      chartererCommOne: 'Charterer Comm',
      delayedComm: 'delayed commission rate',
      demuComm: 'Demurrage Commission',
      demuCommRate: 'Demurrage Commission Rate',
      partnerName: 'Partner Name',
      peopleInfo: 'Economic information',
      cargoName: 'Cargo Name',
      cargoQty: 'Load Qty',
      portCode: 'Load Port',
      tfPortCode: 'Discharge Port',
      portCodeTitle: 'Cargo/loading port information',
      basicCargoQtyRange: 'contact Qty',
      cargoBLQuantity: 'Cargo/Bill of Lading quantity',
      cargoOqMin: 'Excess Qty From',
      cargoOqMax: 'Excess Qty To',
      unloadQty: 'Unload Quantity',
      freightStd: 'Freight Basis',
      freightBillingStd: 'Freight Rate and Billing Standards',
      cargoOqStandards: 'Rate',
      fiveTab: 'Details of expenses',
      sixTab: 'Attachment information',
      saveOne: 'Addition of cabin charge',
      addKuiFee: 'Addition of cabin charge',
      saveTwo: 'Addition Miscellaneous expenses',
      addBasicFreight: 'Addition of basic freight',
      saveThree: 'Import delay charge',
      importDemurrage: 'Import demurrage',
      importVoyageFee: 'Import voyage sundry fee',
      saveFour: 'Add Demurrage fee',
      saveFive: 'Add tenant commission',
      renterComm: 'Renter commission',
      operation: 'operation',
      priseType: 'Type of expense',
      prise: 'Rent Per Day',
      calculation: 'Participation commission calculation',
      cushion: 'Substitute cushion',
      cushionObject: 'Cushion object',
      unit: 'unit',
      Debit: 'Debit',
      Credit: 'Credit',
      basic: 'Basic freight',
      number: 'Base on 100% FRT',
      rentTitle: 'Rent and return home',
      people: 'Broker commission',
      kuiPrice: 'Loss of space',
      sundry: 'sundry charges',
      offSundry: 'Charge off Sundry charges',
      demurrage: 'demurrage',
      excessFreight: 'Excess freight',
      save: 'Save',
      close: 'Close',
      contract: 'View the contract',
      ship: 'Ship dispatching',
      audit: 'audit',
      cancelAudit: 'Cancel Audit',
      priceAudit: 'Submit invoice for approval',
      pay: 'Application for payment',
      print: 'print',
      seal: 'Electronic seal',
      rate: 'Charterer/owner rating',
      tailStage: 'Tail stage',
      nonTailStage: 'Non-tail stage',
      pendingFreight: 'Pending freight',
      paymentDate: 'Payment Date',
      searchFilter: 'Invoice number can be queried',
      electSeal: 'Elect Seal',
      cancelElectSeal: 'Cancel Elect Seal',
      isElectSealRemark: 'Whether to mark electronic invoices？',
      isCancelElectSealRemark: 'Unmark electronic invoice？',
      electSealSuccess: 'Mark electronic invoices Success',
      cancelElectSealSuccess: 'Unmark electronic invoice Success',
      electSealFail: 'Mark electronic invoices Fail',
      cancelElectSealFail: 'Unmark electronic invoices Fail',
      currentBill: 'Current bill',
      rollBill: 'Go back roll bill',
      printCurrentBill: 'Print Current Bill',
      printRollingBill: 'Print Rolling Bill',
      printPaymentRequest: 'Print Payment Request',
      checkPrintPayment: 'There is no payment application fee and cannot be printed'
    },
    orderAmountDiff: 'The invoice expense line amount is inconsistent with the order. Would you like to update the order?',
    contractTaxRate: 'Contract tax rate(%)',
    uploadinvoice: 'Upload invoice',
    SOAImport: 'SOA import',
    download: 'Download Template',
    matchDetail: 'Matching Detail',
    viewMatchInfo: 'View matching information',
    invoiceTitle: 'invoice Title',
    application: 'User Name',
    invSerialNo: 'Serial No',
    checkName: 'auditor',
    checkTime: 'Audit time',
    searchFilter: 'Search taxInvoiceNo And InvoiceNo',
    searchFilterTwo: 'Search VoyageNo And InvoiceNo',
    searchFilterThree: 'Search taxInvoiceNo And InvoiceNo',
    rpFlagOne: 'RP Flag',
    addstick: 'Generate voyage documents',
    scrap: 'scrap',
    accountNo1: 'Object code',
    bankName1: 'Bank information',
    currency1: 'Currency code',
    bankInfoId: 'FILEID',
    buttonSave: 'Generate voyage documents',
    compLtHan: 'Passed Day',
    compLt: 'Comp',
    isAdvance: 'Advance',
    dueDate1: 'Due Date',
    remark1: 'Describe ',
    toFrt: 'Have Invoice',
    rpFlag: 'RP Flag',
    checkStatus1: 'Examine',
    abandon: 'Status ',
    toArap: 'AR/AP',
    customerName: 'Customer Name',
    portName1: 'Port',
    lastModifyByName1: 'Operator',
    feeType: 'Fee Type',
    taxManagement: 'Tax Invoicing Management',
    taxApplyManagement: 'Tax receipt application management',
    vesselName: 'VesselName',
    voyageNo: 'Voyage No',
    currency: 'Currency',
    businessType: 'Business Type',
    fleet: 'Fleet',
    partner: 'Partner',
    applicationDateFr: 'Application Date Fr',
    applicationDateTo: 'Application Date To',
    applicationStatus: 'Application Status',
    invoiceNo: 'Invoice No',
    settleCompany: 'Settle Company',
    checkTax: 'Check tax',
    taxInvoicing: 'Tax invoicing',
    currencyCode: 'Currency',
    invoiceAmount: 'Invoice amount',
    taxInvoiceAmount: 'Tax invoice amount',
    taxInvoiceAmount02: 'Tax invoice amount',
    taxApplicationTime: 'Application time',
    settledAmount: 'Settled amount',
    balanceAmount: 'Balance amount',
    settledStatus: 'Settled status',
    taxInvoicedAmount: 'Tax invoiced amount',
    spactickTicket: 'Management of special paper tickets',
    business: 'Business management',
    invoicing: 'Tax control invoicing related',
    serviceName: 'Service item',
    taxApplicationStatus: 'Application status',
    partnerName: 'purchaser',
    actualPayer: 'actual payer',
    actualPayee: 'actual payee',
    // invoiceNo: 'Bill number',
    taxinvoice: 'Tax receipt number',
    // invoiceAmount: 'Invoice amount',
    voyageNo2: 'Voyage number',
    settleOfficeName: 'Selling party',
    // currencyCode: 'Type of notes',
    taxCurrencyCode: 'Currency of the tax receipt',
    taxExchangeRate: 'Agreed rate of exchange',
    groupExchangeRate: 'Exchange rate issued by the group',
    invoiceType: 'Type of invoice',
    paperTicket: 'Paper ticket management',
    ElectronicTicket: 'Electronic ticket management',
    applicationDate: 'Application date',
    selectRight: 'Please select the correct organization',
    taxApplyDetailed: 'Tax Invoice Application Details',
    mainInformation: 'Main information',
    invoiceHeader: 'Invoice header',
    taxNumber: 'Tax number',
    bankName: 'Bank name',
    accountNo: 'Account no',
    contactAddr: 'Contact address',
    contactTel: 'Contact telephone',
    partnerTaxNo: 'Partner tax no',
    partnerContactAddr: 'Partner contact address',
    partnerContactTel: 'Partner contact telephone',
    partnerBank: 'Partner bank',
    partnerBankName: 'Partner bank name',
    partnerAccountNo: 'Partner account no',
    partnerContactMobile: 'Partner contact mobile',
    partnerProperty: 'Partner property',
    taxInvoiceType: 'Tax invoice type',
    taxMail: 'Tax mail',
    preTaxInvoiceAmount: 'Pre tax invoice amount',
    taxAmount: 'Tax amount',
    taxRemark: 'Tax remark',
    taxParticular: 'Tax particular',
    otherInformation: 'Other information',
    taxCodeVersion: 'Tax code version',
    propertyRightCode: 'Property right code',
    authenticateCode: 'Authenticate code',
    priceTaxSepFlag: 'Price tax sep flag',
    taxInvoiceUser: 'Tax invoice user',
    receiptUser: 'Receipt user',
    checkUser: 'Check user',
    specialInvoiceType: 'Special invoice type',
    deviceType: 'Device type',
    extNo: 'ExtNo',
    terminalNo: 'Terminal no',
    applicationUserRemark: 'Application user remark',
    proInformation: 'Project information',
    itemName: 'itemName',
    unit: 'unit',
    specification: 'specification',
    tradeCompanyType: 'Nature of invoice',
    zeroRateType: 'Zero tax rate ID',
    taxReliefCode: 'Tax deduction nature code',
    deduction: 'deduction',
    favorablePolicy: 'Favorable policy',
    favorableParticular: 'Favorable particular',
    taxClassify: 'Tax classify',
    quantity: 'quantity',
    price: 'price',
    taxRate: 'Tax Rate',
    tax: 'tax',
    taxTotalAmount: 'Total project price',
    projectSplit: 'Project split',
    redFlush: 'Red flush',
    toVoid: 'to void',
    readyRedFlush: 'Flushed red',
    readyToVoid: 'Obsolete',
    notSaved: 'Not saved',
    image: 'image',
    getImage: 'Image acquisition',
    seeImage: 'Video viewing',
    uploadImage: 'Image upload',
    seeTax: 'Invoice Preview',
    assBlue: 'Associated Blue Ticket',
    seeStatus: 'View sending status',
    submitStatus: 'Request Status',
    businessNo: 'Business no',
    taxInvoiceNo: 'Tax invoice no',
    taxInvoiceCode: 'Tax invoice code',
    taxRelief: 'Tax relief',
    code: 'code',
    rcParticular: 'Reverse/Cancel Particular',
    oriTaxInvoiceInfo: 'Original Invoice Info',
    oriTaxInvoiceNo: 'Original Invoice No',
    oriTaxInvoiceCode: 'Original Invoice Code',
    redInvoiceNo: 'Red Invoice No',
    remark: 'remark',
    reject: 'reject',
    submitSuccessfully: 'Submitted successfully',
    submitFailed: 'Submit failed',
    rejectSuccessfully: 'Rejected successfully',
    rejectFailed: 'Reject failed',
    pleaseSaveFirst: 'Please save first',
    splitAndMainUnequal: 'The "total project price" in the project split is inconsistent with the "tax invoice amount" in the main information',
    notDelete: 'The request status must be "Not Sent"',
    otherManagement: ' Other Expenses Management',
    voyageExpenses: 'Voyage Expenses and Invoice Management',
    invalidFlag: 'Is Invalid',
    paymentIdentification: 'RP Flag',
    moveUp: 'Move Up',
    moveDown: 'Move Down',
    receivable: 'Receivable',
    payable: 'Payable',
    dueDate: 'Due Date',
    approvalStatus: 'Approval Status',
    settleStatus: 'Settle Status',
    invoiceDate: 'Invoice Date',
    invoiceTypeNew: 'Invoice Type',
    invoiceCurrencyNew: 'Invoice Currency',
    invoiceAmountNew: 'Invoice Amount',
    vessel: 'Vessel',
    contractNo: 'Contract No',
    particular: 'Particular',
    creditNoteFlag: 'Invoice/Credit Note Flag',
    invoiceProperty: 'Pro Forma Invoice/Commercial Invoice',
    vvl: 'vesselName/voyageNo',
    voyageExpensesEdit: 'Voyage Expenses and Invoice Detail',
    detailGeneralCheck: 'The payable amount must be greater than or equal to the receivable amount!',
    detailShipCheck: 'The cost details and ship names must be consistent',
    detailContractCheck: 'The contracting parties corresponding to the expense details contract number must be consistent',
    submitForApproval: 'Submit For Approval',
    paymentApply: 'Payment Apply',
    print: 'Print',
    baseInfo: 'Base Information',
    invoiceNumber: 'Invoice No',
    currencyAndRate: 'Invoice Currency and Exchange Rate ',
    settledAmountNew: 'Settled Amount',
    settleCompanyNew: 'Settle Company',
    partnerAccountNoNew: 'Partner ACCT. No',
    partnerAccountName: 'Partner ACCT. Name',
    partnerBankNameNew: 'Partner Bank Name',
    accountNoNew: 'ACCT. No',
    accountName: 'ACCT. Name',
    bankNameNew: 'Bank Name',
    paymentNo: 'Payment No',
    particularNew: 'Particular',
    expenseDetail: 'Expense Detail',
    copyAdd: 'Copy Add',
    otherChargeExport: 'Export expense details',
    batchUpdate: 'Batch Update',
    port: 'Port Name',
    chargeName: 'Charge Name',
    quantityNew: 'Quantity',
    unitPrice: 'Unit Price',
    amountAr: 'Amount AR',
    amountAp: 'Amount AP',
    currencyNew: 'Currency',
    chargeCompany: 'Charge Company',
    finType: 'Financial Type',
    payee: 'Payee',
    apTotal: 'AP Total',
    arTotal: 'AR Total',
    total: 'Total',
    generalExpenses: 'General Expenses Management',
    amount: 'Amount',
    rpTypeFlag: 'R/P',
    rInvoice: 'R',
    pInvoice: 'P',
    atLeastOne: 'Please Select At List One Row',
    checkFlag: 'Is Checked',
    submitFlag: 'Is Submitted',
    audit: 'Audit',
    cancelAudit: 'Cancel Audit',
    invoiceApproval: 'Invoice Approval',
    auditSuccess: 'Audit Success',
    cancelAuditSuccess: 'Cancel Audit Success',
    invalidInvoiceNoNotEmpty: 'Invalid Invoice No Not Empty',
    invalidInvoiceNo: 'Invalid Invoice No',
    associateInvalidInvoiceNo: 'Associate Invalid Invoice No',
    associateInvalidInvoiceNoCheck: 'The current invoice is already associated with invalid invoice no: {invoiceNo}. Do you want to continue?',
    copy: 'Copy',
    invalid: 'Invalid',
    invalidSuccess: 'Invalid Success',
    generalExpensesEdit: 'General Expenses Detail Edit',
    subjectTitle: 'Subject',
    customer: 'Customer',
    createdBy: 'Created By',
    settleFlag: 'Settle Flag',
    receiptDate: 'Receipt Date',
    createDate: 'Created Date',
    cancelReceiveApply: 'Cancel Collecting Apply',
    invalidAndRedo: 'Invalid and Redo',
    currentStatus: 'Current Status',
    handleUser: 'Handle User',
    receiveStatus: 'Collecting Status',
    invoiceApprovalSearch: 'Invoice Approval Search',
    receiptAndPayment: 'Receipt And Payment Approval',
    receiptInvoiceDetail: 'Receipt Invoice Approval Detail',
    submitShare: 'Submit For Share',
    haveRead: 'Have Read',
    viewImage: 'View Images',
    uploadImages: 'Upload Images',
    invoiceInfo: 'Invoice Information',
    approvalOpinion: 'Approval Opinion',
    attachmentInfo: 'Attachment Information',
    amountTotal: 'Total Amount',
    installment: 'Installment',
    voyageNoAndContract: 'Voyage No/Contract Type',
    broker1Name: 'Broker Name',
    broker2Name: 'Broker2 Name',
    broker3Name: 'Broker3 Name',
    brokerName: 'Broker Name',
    currentApprovalStatus: 'Current Approval Status',
    buildTime: 'Created Date',
    contractType: 'Contract Type',
    operateSuccessfully: 'Operate Successfully',
    settleStatusNew: 'Settle Status',
    isChecked: 'Is Checked',
    isSubmit: 'Is Submit',
    isInvalid: 'Is Invalid',
    isElectSeal: 'Is Elect Seal',
    checkFailure: 'Check failure',
    disbursementManagement: 'Disbursement Management',
    disbursementEstimate: 'Disbursement Estimate',
    country: 'Countries and Regions',
    agent: 'Agent',
    isChina: 'Is China',
    isOwnerFlag: 'Is Owner Flag',
    voyageStatus: 'Voyage Status',
    portName: 'Port Name',
    bunkerPort: 'Bunker Port',
    agentName: 'Agent Name',
    originCurrency: 'Currency',
    originAmount: 'Amount',
    baseCurrency: 'Base Currency',
    baseAmount: 'Base Amount',
    checkStatus: 'Is Checked',
    pdaFlag: 'Is PDA Applied',
    paymentStatus: 'Payment Status',
    lastModifyByName: 'Updated By',
    lastModifyTime: 'Updated Date',
    feesSetting: 'Fees Setting',
    shipDispatch: 'Ship Dispatch',
    inverseApproval: 'Inverse Approval',
    pettyCashApply: 'Petty Cash Apply',
    historyAgencyFee: 'Historical Agency Fee',
    HistoryDisbursement: 'Historical Disbursement',
    localAgent: 'Agent',
    origAndRate: 'Origin Currency/Rate',
    dockRepair: 'Is Dock Repair',
    vesselBuildFlag: 'Is Vessel Build',
    inCostFlag: 'Is In Cost',
    isPdaApplied: 'Is Pda Applied',
    paymentStatusNew: 'Payment Status',
    disbursementDetail: 'Disbursement Detail',
    discount: 'Discount',
    reducedAmount: 'Reduced Amount',
    baseReducedAmount: 'Base Reduced Amount',
    discountAmount: 'Discount Amount',
    discountBaseAmount: 'Base Discount Amount',
    countTotal: 'Total',
    pdaApply: 'PDA Apply',
    createdByNew: 'Created By',
    approvalProcess: 'Approval Process',
    pdaDelete: 'Delete PDA Apply',
    cancelPay: 'Cancel Pay And Invalid Apply',
    differentAgentChangePort: 'Change Port For Different Agent',
    sameAgentChangePort: 'Change Port For Same Agent',
    agentNameNew: 'Agent Name',
    payDueDate: 'Due Date',
    agentCode: 'Agent Code',
    isSubmitted: 'Is Submitted',
    portChargeInfo: 'Disbursement Estimate',
    totalBalanceAmount: 'Total Balance Amount',
    applyAmount: 'Amount',
    applyCurrency: 'Currency',
    offsetAmount: 'Offset Amount',
    paymentAmount: 'Apply Amount',
    basePaymentAmount: 'Base Apply Amount',
    docNo: 'Doc No',
    paymentDueDate: 'Due Date',
    balanceDetail: 'Balance Detail',
    fdaInvoiceNo: 'FDA Invoice No',
    offsetAmountNew: 'Offset Amount',
    add: 'Add',
    pdaBalanceAmount: 'PDA Balance Amount',
    createTime: 'Create Time',
    payApply: 'Payment Apply Management',
    payeeName: 'Payee Name',
    supplier: 'Supplier',
    approvalStatusNew: 'ApprovalStatus',
    freightType: 'Freight Type',
    shareStatus: 'Share Status',
    receiptDateNew: 'Receipt Date',
    paymentPriority: 'Payment Priority',
    payCurrency: 'Currency',
    payAmount: 'Amount',
    payApprovalStatus: 'Handle User',
    paidDate: 'Paid Date',
    bankSlip: 'Bank Slip',
    payCancel: 'Cancel Pay ',
    reportInfo: 'Report Info',
    checkBankInfo: 'checkBankInfo',
    printOrder: 'Print Order',
    printPdf: 'Print PDF',
    company: 'Company',
    createdPerson: 'Created By',
    createdDep: 'Created Dep',
    paymentMeans: 'Payment Means',
    amountForNow: 'Amount',
    paymentParticular: 'Payment Particular',
    receiptInfo: 'Receipt Info',
    payeeBankName: 'Bank Name',
    payeeAccountNo: 'Accout NO',
    paymentDetail: 'Payment Detail',
    receiptDetail: 'Receipt Detail',
    invoice: 'Invoice No',
    expenseAmount: 'Amount',
    receivedRemark: 'Received Remark',
    addReceipt: 'Add Receipt',
    invoiceDetail: 'Invoice Detail',
    insuranceItem: 'Insurance Item',
    underwriteDate: 'Underwrite Date',
    installmentNew: 'Installment',
    payApplyEdit: 'Pay Apply Edit',
    paymentApplicationForm: 'Payment Application Form',
    paymentNoNew: 'Payment No',
    invoiceNoRepeatedly: 'Invoice No Repeatedly',
    mustInput: 'Please input content required',
    detailEmpty: 'The expenses row can not be empty',
    rowNumCheck: 'Line {seq} : {attribute} can not be empty',
    detailNotSave: 'The expenses row should be saved',
    demurrageManagement: 'Demurrage management',
    calculationOfDemurrage: 'Calculation of demurrage',
    frightRentManagement: 'Fright and Rent Management',
    rentOutPendingHireFrt: 'Freight and rent to be handled for chartering out',
    rentInPendingHireFrt: 'Freight and rent to be handled for chartering in',
    rentOutHireFrtInvoice: 'Invoice for freight and rent for chartering out',
    rentInHireFrtInvoice: 'Invoice for freight and rent for chartering in',
    nextPayDay: 'nextPayDay',
    currentPeriod: 'currentPeriod',
    type: 'type',
    agreement: 'agreement',
    renter: 'Renter',
    shipOwner: 'Ship Owner',
    delayTime: 'Delay time',
    dispatchTime: 'dispatch time',
    demurrageCharges: 'demurrage charges',
    dispatchMoney: 'dispatch money',
    adjustmentAmount: 'Adjustment amount',
    total2: 'Total',
    importInvoice: 'Import Invoice',
    updateDocument: 'Update document',
    viewContract: 'View contract',
    uploadAttachments: 'Upload attachments',
    generateDelayFeeInvoice: 'Generate delay fee invoice',
    shipSource: 'Ship source',
    cargo: 'cargo',
    billReceiver: 'Bill receiver',
    invoicingParty: 'Invoicing party',
    totalLoadingAndUnloading: 'Total loading and unloading',
    demurrageChargesDay: 'Demurrage (/day)',
    dispatchFee: 'Dispatch fee (/day)',
    portList: 'Port list',
    lagTime: 'Delay time (days)',
    purpose: 'purpose',
    cargoVolume: 'Cargo volume',
    handlingEfficiency: 'Handling efficiency',
    unit1: 'unit',
    demurrageClause: 'Demurrage clause',
    startTime: 'start time',
    startDate: 'start Date',
    startClause: 'start Clause',
    completionTime: 'Completion time',
    completionDate: 'Completion Date',
    completionClause: 'completion Clause',
    expectedTime: 'Expected time',
    percentage: '%',
    usageTime: 'Usage time (days)',
    allowedTime: 'Allowed time (days)',
    allowedTime2: 'Allowed time',
    earlyLoadingTime: 'Early loading time (days)',
    earlyLoadingTime2: 'Early loading time',
    deductionTime: 'Deduction time (days)',
    deductionTime2: 'Deduction time',
    date: 'date',
    week: 'week',
    time: 'Time (hours)',
    adjustmentAmount2: 'Adjustment amount(%)',
    finalTime: 'Final time (days)',
    cumulativeTime: 'cumulative Time',
    operate: 'operate',
    delayTime2: 'Delay time (days)',
    demurrageRate: 'Demurrage Rate',
    dispatchRate: 'Dispatch rate',
    deductionItems: 'Deduction/Early Installation Project',
    time2: 'time',
    endTime: 'End time',
    fatalism: 'fatalism',
    deductibleDays: 'deductible Days',
    cause: 'cause',
    describe: 'describe',
    boatmanView: 'Tenant perspective',
    renterView: 'Shipowner\'s perspective',
    disputeRecord: 'Dispute record',
    disputeType: 'Dispute type',
    processingResults: 'Processing results',
    demurrageFee: 'Demurrage fee',
    agreementAmount: 'Agreement amount',
    chartererAmount: 'charterer Amount',
    ownerAmount: 'owner Amount',
    calculationTimeCharge: 'Calculation time point of delay charge',
    importInvoiceOrNot: 'Import invoice or not',
    SOFDetails: 'SOF details',
    actualPortCharge: 'Actual Port Charge',
    portCountry: 'Country',
    isLocked: 'Is Locked',
    docApprovalStatus: 'Inv. Approval Status',
    paymentApprovalStatus: 'Payment Approval Status',
    docNoNew: 'DOC No',
    actualAmount: 'Invoice Amount',
    paymentAmountNew: 'Payment Amount',
    invApprovalStatus: 'Inv. Approval Status',
    operationDeptTotal: 'Operation Dept. Total',
    engineerDeptTotal: 'Engineer Dept. Total',
    crewDeptTotal: 'Crew Dept.Total',
    superviseDeptTotal: 'Supervise Dept. Total',
    safetyDeptTotal: 'Safety Dept. Total',
    createdOffice: 'Created Office',
    batchPayApply: 'Batch Pay Apply',
    importPortCharge: 'Import Port Charge',
    lock: 'Lock',
    unlock: 'Unlock',
    adjustCharge: 'Adjust Charge',
    adjustInvoiceNo: 'Adjust InvoiceNo',
    setPortChargePaid: 'Mark PortCharge Paid',
    portChargeBalanceAmount: 'Port Charge BalanceAmount',
    paymentNoRepeat: 'PaymentNo Repeat!',
    deleteFailed: 'Delete failed,check the approval status',
    onlyDeleteChecked: 'You can only delete the data without check!',
    cancelReceive: 'Cancel Receiving',
    demurrageDisputeInquiry: 'Demurrage dispute inquiry',
    contractDate: 'contract date',
    route: 'air line',
    contractTemplate: 'Model Contract',
    issue: 'issue',
    relevantContractTerms: 'Relevant Contract Terms',
    demurrageinvoicemanage: 'Delay fee invoice management',
    currencyName: 'currency',
    endOfVoyage: 'End of voyage',
    pdaOffsetNotEnough: 'PDA offset not enough,please redo after refresh',
    totalAmount: 'Total amount',
    arrivalDate: 'Arrival Date',
    departureDate: 'Departure Date',
    portPurpose: 'Port Purpose',
    settlePartnerCode: 'Partner',
    isDocCollected: 'Is Doc Collected',
    fdaReceiveDate: 'FDA Received Date',
    applyPda: 'PDA Applied',
    paymentAmountForNow: 'Payment Amount',
    voyageExpensesNew: 'Voyage Expenses',
    pdaBalanceFlag: 'PDA Balance Flag',
    substitutePartner: 'Substitute Partner',
    allinFlag: 'Is Allin',
    substituteFlag: 'Is Substituted',
    substitutePartnerNameEn: 'Substitute Partner',
    claimFlag: 'Is Claim',
    claimNo: 'Claim No',
    undertakeCompanyNameEn: 'Undertake Company',
    csNameEn: 'Cust&Supp',
    partnerNameEn: 'Partner',
    settleCompanyNameEn: 'Settle Company',
    currencyCodeBaseAndExchange: 'Currency/Base Currency/Exchange Rate： ',
    particularDescribe: 'Particular',
    pdaDiscountAmount: 'Estimate Discount Amount',
    difference: "Difference",
    substituteAmount: 'Substitute Amount',
    spareStoreType: 'Spare&Store Type',
    op: 'Operation Department',
    eg: 'Engine Department',
    cw: 'Crew Department',
    su: 'Safety Supervision Department',
    sa: 'Safety and Quality Department',
    approvalStatusForDoc: 'Approval Status',
    choseInvoiceDate: 'Please select invoice date first',
    cantDelete: 'Check the approval status and check flag!',
    fdaAmount: 'FDA Amount',
    pdaAmount: 'PDA Amount',
    pdaBalanceType: 'PDA Balance Type',
    auditTime: 'Audit time',
    delayFeeCalculation: 'Delay fee calculation',
    leadingIn: 'leading-in',
    importSuccess: 'Import Success',
    contractingEntity: 'Contracting entity',
    surplusPdaQuery: 'Surplus Pda Query',
    submitReceipt: 'Submit for Receipt',
    setPdaTypeToPda: 'Set to PDA',
    setPdaTypeToBalance: 'Set to Balance',
    vesselCode: 'Vessel Code',
    agentCodeNew: 'Agent Code',
    balanceAmountNew: 'Balance Amount',
    pdaType: 'PDA Type',
    createOffice: 'Created Office',
    portSequence: 'Port Sequence',
    pdaStatus: 'PDA Status',
    isBalanceZero: 'Is Balance Zero',
    totalPdaAmount: 'Total Balance Amount',
    sureUpdatePda: 'Change PDA type to "PDA" or not? ',
    sureUpdateBalance: 'Change PDA type to "Balance" or not? ',
    updateSuccessfully: 'Update successfully',
    updateFailed: 'Update failed',
    contractNoEmpty: 'Contract No cannot be empty',
    modifyRemark: 'Modify Remark',
    pdaDetail: 'PDA detail',
    offsetStatus: 'Offset Status',
    surplusPdaRetrieve: 'Surplus Pda Retrieve',
    partnerNameNew: 'Partner Name',
    invRemark: 'Particular',
    surplusPdaRetrieveDetail: 'Surplus Pda Retrieve Detail',
    receiptApproval: 'Submit for Approval',
    bankInfoNew: 'Bank Info',
    hcbCode: "hcbCode",
    issueInfo: 'Issue Info',
    chargeInfo: 'Expenses Info',
    chargeNameNew: 'Charge Name',
    validFailed: 'The selected agent and currency must be consistent, and the balance cannot be zero.',
    handleHomeCurrency: 'Please set the home currency of company!',
    marketInformation: 'Market Information',
    fuelPriceIndex: 'Fuel Price Index',
    portFuelPriceIndex: 'Port Fuel Price Index',
    portFuelPriceIndexDetails: 'Port Fuel Price Index Details',
    indexDate: 'Index date',
    priceUM: 'Price (USD/MT)',
    upDownAmount: 'Up and down amount',
    index: 'index',
    fluctuationRange: 'Fluctuation range',
    indexType: 'Index type',
    cycleTime: 'cycle time',
    queryDate: 'Query date',
    PortSettings: 'Main refueling port settings',
    pricePreviousDay: 'Price of the previous day',
    dayPrice: 'Day price',
    aparManagement: 'Ap/Ar Manage',
    settlementAr: 'Settlement AR',
    settlementAp: 'Settlement AP',
    voyageEndDate: 'Voyage End Date',
    settleMarks: 'Settle Status',
    partnerNew: 'Partner',
    customerPay: 'Customer',
    invoiceAmountR: 'Invoice Amount',
    receiptAmount: 'Receipt Amount',
    balanceAmountR: 'Balance Amount',
    estDueDate: 'Est Due Date',
    voyageEnd: 'Voyage End Date',
    voyageEnd5: 'Voyage End Date+5',
    settlementArDetail: 'Settlement AR Detail',
    arrears: 'Balance Amount',
    dueTime: 'Due Date',
    settleCurrency: 'Invoice Currency',
    homeCurrency: 'Base Currency',
    exchangeRate: 'Exchange Rate',
    receiptType: 'Receipt Type',
    receiptInformation: 'Accounts receivable',
    actualReceipts: 'Actual receipts',
    freightIndex: 'Freight index',
    tankerFreightIndex: 'Tanker freight index',
    TCEMean: 'TCE mean (USD$/DAY)',
    TCEMean2: 'TCE mean',
    TCEFluctuation: 'TCE fluctuation',
    TCEUpsDowns: 'TCE Ups and Downs',
    detailsOfTankerFreightIndex: 'Details of tanker freight index',
    indexPreviousDay: 'Index of the previous day',
    indexDay: 'Index of the day',
    TCEDayBefore: 'TCE the day before',
    indexRounte: 'index rounte',
    indexText: '*Double click to view or maintain more detailed index type data',
    saveSuccess: 'Successfully saved',
    saveFailed: 'Save failed',
    manageCompany: 'Manage Company',
    nextDay: 'Next Day',
    dryBulkFreightIndex: 'Dry bulk freight index',
    detailsOfDryBulkFreightIndex: 'Details of Dry bulk freight index',
    prepaidCancellation: 'Settle Advance Receipt',
    payerBankAccount: 'Payer Bank Account',
    bankCharges: 'Bank Charges',
    annotation: 'Particuar',
    notNull: 'This table cant be empty.',
    payAmountNew: 'Amount',
    paidAmount: 'Paid Amount',
    payBalanceAmount: 'Balance Amount',
    voyageEndTime: 'Voyage End Date',
    settleAmount: 'settleAmount',
    settleDate: 'Settle Date',
    duePayDate: 'Due Date',
    bankSlipNew: 'Bank Slip',
    settlementApDetail: 'Settlement AP Detail',
    actualPayInfo: 'Actual Payment Info',
    approvalHistory: 'Approval Process',
    processName: 'Process Name',
    department: 'Department',
    handler: 'Handler',
    arrivalTime: 'Arrival Time',
    handleTime: 'Handle Time',
    timeGap: 'Time Gap',
    status: 'Status',
    historyAgentCharge: 'Historical agency fee',
    ourBankInfo: 'Bank Info',
    partnerBankInfo: 'Partner Bank Info',
    filterInvoiceNo: 'Invoice No',
    invoiceNoSubject: 'Invoice No,Subject Title',
    payInvoiceNo: 'Invoice No、Payment No、Payee Name',
    filterRemark: 'remark',
    taxReceiptInfo: 'Supplier Tax Invoice Info',
    withdraw: 'Withdraw',
    invoiceCode: 'Invoice Code',
    invoiceNumberNew: 'Invoice No',
    invoiceAcceptDate: 'Invoice Accept Date',
    isOffset: 'Is Offset',
    offsetAmountOff: 'Offset Amount',
    invoiceCurrency: 'Currency',
    preTaxInvoiceAmountNew: 'Pre-Tax Invoice Amount',
    taxMoney: 'Tax ',
    invoiceMoney: 'Invoice Amount',
    invoicePartner: 'Partner',
    partnerTaxNumber: 'Partner Tax No',
    partnerAddrTel: 'Partner Address&Tel',
    bankAccount: 'Partner Bank&Account',
    receiptCompany: 'Settle Company',
    taxNo: 'Tax No',
    addrTel: 'Address&Tel',
    bankAndAccount: 'Bank&Account',
    serviceNameNew: 'Service Name',
    chargeRelate: 'Charge Name',
    preAmount: 'preTaxInvoiceAmount',
    taxRateNew: 'Tax Rate(%)',
    taxAmountNew: 'Tax',
    invoiceTaxAmount: 'Invoice Amount',
    submitFlagNew: 'Is Submit',
    supplierAdd: 'Supplier Tax Bill',
    submit: 'Submit',
    invoiceOcr: 'Invoice OCR',
    billingDetails: 'Billing Details',
    specificationNew: 'Specification',
    deleteImage: 'Delete Image',
    submitSuccess: 'Submit successfully',
    successfulWithdrawal: 'Successful withdrawal',
    onlyOne: 'Select at most one piece of data',
    amountDifferent: 'Inconsistency between the cost in the main information and the cost details!',
    amountDiff: 'Invoice and tax invoice costs do not match！',
    alreadySubmit: 'The tax receipt has been submitted and cannot be deleted.',
    shareSuccess: 'Share successfully',
    checkBanInfo: 'Please check if the bank information is correct.',
    checkHomeCurrency: 'Please maintain the company’s home currency',
    checkInvoiceNo: 'Please input the invoice No.',
    checkBatchPay: 'The currency , partner , and PDA balance flag must be consistent, and the approval status must be "approved", as well as the submit flag must be "no".',
    portChargeAmount: 'Port Charge',
    sameAmount: 'Invoice amount should be consistent with the sum of amount (after discount) in each cost table.',
    payApproveStatus: 'Approval Status',
    settleOffice: 'Settle Company',
    sendFlag: 'Send Flag',
    apNo: 'AP No',
    voucherNo: 'Voucher No',
    returnStatus: 'Return Status',
    auditInformation: 'Audit Information',
    auditDate: 'Audit Date',
    settleAmountNew: 'Settle Amount',
    arNo: 'AR No',
    isTaxInv: 'Is Tax Inv.',
    saveFirst: 'Please save first.',
    invoiceDates: 'Invoice Date',
    receiptDates: 'Receipt Date',
    applyStatus: 'Approval Status',
    totalPreTaxInvoiceAmount: 'Pre-Tax Invoice Amount',
    totalTaxAmount: 'Tax ',
    totalInvoiceAmount: 'Invoice Amount',
    noImage: 'No image files,please upload first.',
    pdaNotEnough: 'Balance amount of PDA not enough',
    pleaseSaveData: 'Please Save Data',
    ocrFail: 'The ocr identification fails.',
    selectOpt: 'Please select the approval option',
    unsettleAmount: 'Unsettled Amount',
    paidType: 'Paid Type',
    payApprovalProcess: 'Pay Apply Approval Process',
    docApprovalProcess: 'Doc Approval Process',
    pleaseUpdateRate: 'Please update the exchange rate of currency',
    fillTable: 'Please complete all required fields in the form',
    notaxAmount: 'No Tax Amount',
    exTaxation: 'Tax',
    exTaxation2: "<label style='color:red'>*</label> Tax",
    voyageCostFlag: 'Is Voyage Cost',
    tipOne: 'The status must be unsent and not associated with blue ticket information',
    tipTwo: 'The status must be either sent or not occurred and associated with blue ticket information',
    sendSuccess: 'Send success',
    tip: 'Tip',
    isSend: 'Is send',
    isRedFlush: 'Is Red Flush',
    isToVoid: 'Is To Void',
    pleaseChooseOneSend: 'Please choose one send',
    mustHasRcParticular: 'Must has rcParticular ',
    redFlushSuccess: 'Red Flush Success',
    toVoidSuccess: 'toVoid Success',
    totalFormTo: 'Total From to',
    sendInfo: 'Preview of current blue ticket sending information',
    redFlushInfo: 'Preview of current Red Flush sending information',
    toVoidInfo: 'Preview of current Void sending information',
    nameCn: 'Name Cn',
    nameEn: 'Name En',
    invoiceHeader02: 'Invoice Header',
    taxNumber02: 'Tax Number',
    contactAddress: 'Contact address',
    phone: 'phone',
    cantDeleteNew: 'Check the approval status and check flag!',
    check: 'check',
    preview: 'preview',
    voyageOtherFee: 'Voyage Other Fee Query',
    commission: 'commission',
    commissionTitle: 'Broker commission invoice',
    addBrokerageFee: 'Add broker commission',
    generateNewInvoice: 'Generate New Invoice',
    generateNewInvoiceCheck: 'Voided invoices must be checked in order to generate new invoices',
    rentBillDonotrebill: 'Rolling bills do not support rebilling',
    generateNewInvoice2: 'The deprecated invoice already has a new invoice',
    selectOne: 'Please select a piece of data',
    invoiceStatus: 'Invoice Status',
    obtainIndexRent: 'Obtain Index Rent',
    addExpenses: 'Add expenses',
    defaultInitializationFee: 'Default initialization fee',
    checkTheInitializationFee: 'Check the initialization fee',
    brokerCommFee: 'Amount (including broker commission)',
    importFromOrder: 'Import from order',
    invoiceDetails: 'Invoice Details List',
    commissionDetailCheck: 'Please maintain at least one expense detail!',
    saveCommission: 'Add Commission',
    lockSuccess: 'Lock success',
    unlockSuccess: 'Unlocking succeeded',
    tempOffset: 'Offset',
    obtain: 'obtain',
    view: 'view',
    upload: 'upload',
    isObtain: 'is Obtain',
    isView: 'is view',
    isUpload: 'is upload',
    partnerNotNull: 'Please input the partner',
    currencyNotNull: 'Please input the currency',
    pdaOffsetAdd: 'Add PDA',
    pdaOffsetDelete: 'Delete PDA',
    pdaOffsetSearch: 'View PDA Balance',
    obtainSuccess: 'Image acquisition successful',
    obtainFail: 'Image acquisition failed',
    uploadSuccess: 'Image uploaded successfully',
    uploadFail: 'Image upload failed',
    onlyPda: '',
    invalidAndRestartInvoice: 'Invalid',
    cancelReceiveSuccess: 'Successful cancellation of collection',
    adjustCollectionInfo: 'Adjust collection information',
    send: 'Send',
    adjustSuccess: 'Adjustment success',
    bankOfDeposit: 'Bank name',
    bankAccountNumber: 'Bank name',
    noCreateOffice: 'No Create Office!',
    noTaskCode: 'TaskCode cannot be empty!',
    submitShareSuccess: 'Submit successfully',
    unApproval: 'Inverse Approval',
    cancelPaySuccess: 'Cancel paying successfully',
    shareAuditDate: 'Share Audit Date',
    shareAuditor: 'Share Auditor',
    shareAuditInfo: 'Share Audit Info',
    shareInfo: 'Share Info',
    returnToCreator: 'Return to Creator',
    update: 'Update',
    updateFreightTerms: 'update Freight Terms',
    portNameEn: 'Port Name En.',
    returnCreatorSuccess: 'Call back to the creator successfully',
    workFlowNotPass: 'The work flow did not pass.',
    approvalOpinionForCancel: 'Approval Opinion for Cancel Receiving.',
    approvalOpinionForInvalid: 'Approval Opinion for invalidation.',
    updateInfo: 'Update Information',
    checkDocStatus: 'Check the status!',
    submitApproveSuccess: 'Submitted successfully for approval',
    repeatDocNo: 'Repeated Doc No.',
    viewPda: 'View PDA',
    noPda: 'No PDA now.',
    discountNotaxAmount: 'No Tax Amount',
    baseExTaxation: 'Tax',
    discountBaseNotaxAmount: 'Base No Tax Amount',
    paymentAmountLimit: 'The total amount of this payment should be greater than 0.',
    paymentAmountZeroLimit: 'The payment amount for this transaction should be greater than 0.',
    userToApproval: 'Pending approver',
    userToApprovalNext: 'Next-level approver',
    payFinConfig: 'Payment Approval Configuration',
    recFinConfig: 'Accounts Receivable Approval Configuration',
    fdaAdd: 'Add FDA',
    opsSettleOffice: 'Operating company',
    estimateAmount: 'Estimate Amount',
    viewPdaBalance: 'View PDA Balance List',
    viewPdaBalanceList: 'View PDA Balance List',
    balance: 'Balance',
    pdaRecycleNo: 'Internal AR Code',
    signSubject: 'Sign Subject',
    payCurrencyAndRate: 'currency',
    amountForPay: 'Payment Amount',
    shareAuditUser: 'Finance Approver',
    payDate: 'Pay Date',
    payBank: 'Pay bank No',
    settlementAm: 'Settle Amount',
    noImageNo: 'No Image No.',
    shareReturnDate: 'Return Date',
    bankCharge: 'Bank Charge',
    payParticular: 'particular',
    payPlan: 'Pay Plan',
    universalList: 'Universal List',
    viewUniversal: 'View Universal',
    discountMoney: 'Discount Amount',
    baseAmountTax: 'Base Amount Tax',
    costElement: 'ost Element',
    costNature: 'Cost Nature',
    specialCount: 'Special Count',
    buildTimeNew: 'Create Time',
    goodsShipping: 'Goods Shipping',
    category: 'category',
    actualTotalPrice: 'Actual Total Price',
    goodsDate: 'Goods Date',
    goodsQuantity: 'Goods Quantity',
    basePaymentAmountNew: 'Base Payment Amount',
    chargeNameFin: 'Charge Name',
    claimFlagNew: 'Claim Flag',
    originAmountPay: 'Amount',
    reducedAmountPay: 'Reduced Amount',
    discountAmountPay: 'Discount Amount',
    discountNotaxAmountPay: 'No Tax Amount',
    orderInfo: 'Order Information',
    arAmount: 'Amount',
    baseArAmount: 'Base Receive Amount',
    revTypeCode: 'Rev Type Code',
    revCash: 'Rev Cash',
    routeLine: 'Route Line',
    portAgentNo: 'Port Agent No',
    revPlan: 'Rev Plan',
    receivableDate: 'Receivable Date',
    detailInfo: 'Detail Info',
    receiptDetailNew: 'Receipt Detail',
    invoiceName: 'Invoice Name',
    taxpayerNum: 'Tax Payer Num',
    accountNoForRec: 'Account No',
    invoiceNum: 'Invoice Num',
    addressTelephone: 'Address and Telephone',
    responseMessage: 'Response Message',
    deletePda: 'Delete',
    notPayApply: 'The selected PDA has not been submitted for payment application to the shared center.',
    pdaPaid: 'The selected PDA has been paid and cannot be .',
    passToDelete: 'Payment can only be cancelled after the payment approval has been passed.',
    uploadImageTip: 'Is it necessary to upload image files?',
    cantUpdateForShare: 'The payment application has been shared, and the due date cannot be modified.',
    updateDueDate: 'Update Due Date',
    payForChangePort: 'PDA has not been paid, cannot change port.',
    yes: 'Yes',
    no: 'No',
    swiftCode: 'SWIFT CODE',
    recoverSuccess: 'Recovery success',
    recover: 'recover',
    balanceSelected: 'The type of PDA selected is the balance,port change operation cannot be performed',
    portSequenceNew: 'Port Sequence',
    currentApproveStatus: 'Approval Status',
    invalidContractType: 'The contract status of the invoice is void, and it is not possible to issue a receivable approval form.',
    endContractType: 'The contract status of the invoice is terminated. Are you sure you want to proceed with issuing the receivable approval form?',
    pdaNewPort: 'Is this data for voyages without port calls? Once confirmed, port and agent data will be editable.',
    queryImageCount: 'Image Count',
    undertakeCompany: 'Undertake Company',
    updateDetailInfo: 'Whether or not to make sure that the update fee details?',
    insInvoiceApprovalDetail: 'Insurance receivable approval',
    insInvoiceDetail: 'Invoice Detail',
    receiptSplit: 'Receipt Detail',
    notShare: 'Not Send',
    shared: 'Sended',
    receiptNo: 'Invoice No',
    shareChecked: 'Approved',
    shareReturn: 'Returned',
    R: 'eceived',
    deleteDraft: 'Delete failed,check the approval status',
    payReport: 'Payment report',
    deleteImageSuccess: 'Deleting the image file succeeded',
    uploadAttachmentsImages: 'Upload attached image file',
    uploadImageSuccess: 'Successfully uploaded the attached image',
    AssociateChiefData: 'Associate Chief Officer data cannot be empty',
    updateFdaInfo: 'Update invoice No, invoice date and due date',
    getReportUrlFailed: 'Failed to obtain the url',
    cancelReason: 'Reason for cancellation',
    invalidlReason: 'Reason for abandonment',
    viewCancelProcess: 'View cancellation/abandonment reinvoicing approval form',
    invalidAndRestartSuccess: 'Rescinded and re-invoiced successfully, invoice No:',
    voyageRange: 'Voyage Range',
    invalidConfirm: 'Whether to invalidate the record',
    sendAndChangePort: 'Update port and inform finance',
    pdaInfo: 'PDA Information',
    payStatus: 'Payment Stauts',
    oldPortInfo: 'Old Port Information',
    newPortInfo: 'New Port Information',
    paymentReportCheck: 'There must be at least one attachment of the type of "proof document for non platform procurement" and at least one attachment of the "quotation list file"',
    cancelReceiptApproval: 'Cancellation of collection approval',
    restartApproval: 'Scrap and invoice for approval',
    cancelReceiptApprovalDetail: 'Cancel the receipt approval details',
    restartApprovalDetail: 'Scrap and re-invoice approval details',
    invoiceNoPaymentNoTitle: 'Invoice number, payment requisition number, title can be queried',
    localApproval: 'local Approval',
    waybillNoAndInvoiceNo: 'Can Search waybillNo And InvoiceNo',
    sendDate02: 'send Date',
    courierCompany: 'courierCompany',
    waybillNo: 'waybillNo',
    recipient: 'recipient',
    invoiceNo01: 'invoiceNo01',
    vesselNameAndVoyageNo: 'vesselNameAndVoyageNo',
    createName: 'createName',
    createName01: 'createName',
    createTime01: 'createTime',
    expressStatus: 'expressStatus',
    deleteFailed01: 'The deleted record must be unsent',
    invoiceCreateName: 'Invoice creator',
    expressStatusRemark: 'Sending status',
    confirmSendOff: 'Sending confirmation',
    customerSignOfConfirm: 'Customer signature confirmation',
    invoiceNoAndCargo: 'Goods can be checked',
    timeOfArrival: 'Arrival Date',
    timeOfDeparture: 'Departure Date',
    estAmount: 'Est Port Charge',
    fdaActualAmount: 'FDA',
    pdaApplyAmount: 'PDA',
    portAgent: 'Agent',
    pdaPaidDate: 'PDA Paid Date',
    fdaSettleType: 'FDA Settle Type',
    fdaNoAndPdaNo: 'FDA invoice number and PDA payment number are available',
    pdaPaymentNo: 'PDA Payment No',
    pdaPaidTime: 'PDA Settle Date',
    pdaBalanceAmountNew: 'PDA Balance Amount',
    balanceHistory: 'Balance History',
    pdaBalancesType: 'PDA Type',
    fdaNoInvoice: 'FDA Invoice',
    overDueDays: 'Overdue',
    fdaCurrencyCode: 'FDA Currency',
    fdaInvoiceAmount: 'FDA Amount',
    offsetAmountForNow: 'Offset Amount',
    fdaRpBalance: 'FDA Balance',
    settleType: 'FDA Settle Type',
    fdaApprovalStatus: 'FDA Approval Status',
    payApplyApprovalStatus: 'Payment Approval Status',
    fdaSettleDate: 'FDA Settle Date',
    agentSettleDate: 'Agent Settle Date',
    agentSettleFlag: 'Agent Settle Flag',
    viewCancel: 'View cancellation approval form',
    viewInvalid: 'View abandonment reinvoicing approval form',
    inChinaFlag: 'Is China',
    discountRate: 'Discount Rate',
    disAmount: 'Discount Amount',
    reduceAmount: 'Reduced Amount',
    selectFeeType: 'Please select feeType',
    handleTaskNode: 'Current Node',
    dpDate: 'Departure Date',
    dpDateMore: 'Departure Date Add 30',
    fdaOffsetBalance: 'Balance After FDA Offset',
    balanceRecoveryDate: 'Balance Recovery Date',
    balanceSettleDate: 'Balance Settled Date',
    balanceOffsetDate: 'Balance Offset Date',
    currentWorkflow: 'Current Workflow',
    index1: 'Index1',
    index2: 'Index2',
    index3: 'Index3',
    oldPortNameEn: 'Former Port',
    balanceChangePort: 'The selected PDA type is the balance, can not change the port',
    payName: 'Partner Name',
    signArea: 'Sign Area',
    year: 'Year',
    sealNo: 'Seal No',
    cancelInvoiceNo: 'Cancel Invoice No',
    particularDes: 'Particular',
    ageDate: 'Aging Date',
    analysisType: 'Analysis Type',
    voyageLine: 'Voyage Line',
    regions: 'Countries and Regions',
    receiveDate: 'Settle Date',
    aging: 'Aging',
    day30: 'In 30 Days',
    day90: '31-90',
    day180: '91-180',
    day365: '181-365',
    day730: '366-730',
    day99999: 'More than 730',
    collectionDate: 'Collection Date',
    chartererReplyDate: 'Charterer Reply Date',
    ownerCounterDate: 'Owner Counter Date',
    collectionContent: 'Collection Content',
    vesselType: 'Vessel Type',
    indexFlag: 'Index',
    inputDepTime: 'Please input start Departure Time',
    inputAnalysisType: 'Please select analysis type',
    inputAgeDate: 'Please select aging date',
    customerReply: 'Customer Reply',
    collectionInfo: 'Collection Content',
    counterDate: 'Owner Counter Date',
    currencyExchangeRate: 'Currency/Exchange Rate',
    otherFinInfo: 'Other Info',
    newBaoBei: 'New Report',
    editBaoBei: 'Edit Report',
    remake: 'redraft',
    bankAccountNo: 'Account No',
    updateMainInfo: 'Whether to update invoice no, invoice date and due date',
    inputMainInfo: 'Please input invoice no, invoice date and due date',
    vesselFlag: 'Owned boat/Chartered boat',
    agingRange: 'Aging Range',
    noBankImage: 'No bank receipt yet',
    bankImageNo: 'Bank Receipt Imange No.',
    lastMonth: 'Last Month',
    thisMonth: 'Current Mounth',
    receiveBack: 'Take Back',
    changeAmount: 'Variation',
    payCustomer: 'Payer',
    settleCurrencyCode: 'Currency',
    portQuantity: 'Port Quantity',
    selectSettleOfficeCode: 'Please select settle office',
    noResultToReport: 'No query result is available. You do not need to export the query result',
    receivingSide: 'The recipient can be queried',
    sureToCancel: 'Whether to confirm cancellation of payment',
    aPortTime: 'Arrival Date',
    unReceivedAmount: 'Uncollected Amount',
    confirmremoval: 'Confirm removal'
  }
};